"use client"

import * as React from "react"
import { Moon, Sun, Laptop } from "lucide-react"
import { useTheme } from "next-themes"

import { cn } from "@/lib/utils"

type ModeSwitcherProps = {
  compact?: boolean;
};

export function ModeSwitcher({ compact = false }: ModeSwitcherProps = {}) {
  const { setTheme, theme } = useTheme()

  const themes = [
    { name: "light", icon: Sun },
    { name: "dark", icon: Moon },
    { name: "system", icon: Laptop },
  ]
  return (
    <div className={cn("flex flex-row", compact ? "gap-1" : "gap-2")}>
      {themes.map((item) => (
        <button
          key={item.name}
          onClick={() => setTheme(item.name)}
          className={cn(
            "rounded-full transition-colors",
            compact ? "p-1.5" : "p-2",
            theme === item.name
              ? "bg-primary text-white"
              : "bg-transparent text-foreground/72 hover:bg-muted hover:text-foreground"
          )}
        >
          <item.icon className={compact ? "h-4 w-4" : "h-5 w-5"} />
        </button>
      ))}
    </div>
  )
}
